import { TableState as OptimusTableState } from '@optimus-web/core';
import { GuestInHouseOrdering, Order } from '@mews-commander/data-access';
import { createHandler } from '@mews/std';
import { ReservationsTableColumns } from '../columns';
import { Columns, ReservationTableFilters, ReservationsTableState } from '../../table';

const defaultOrderParams = {
    orderBy: GuestInHouseOrdering.Space,
    order: Order.Ascending,
};

type TableState = OptimusTableState<ReservationsTableState, ReservationTableFilters>;

const orderByHandler = createHandler<Columns, GuestInHouseOrdering>(
    {
        [ReservationsTableColumns.Space]: GuestInHouseOrdering.Space,
        [ReservationsTableColumns.Customer]: GuestInHouseOrdering.Customer,
    },
    defaultOrderParams.orderBy
);

export const useOrderParams = (sort: TableState['sort'] | undefined) => {
    if (!sort) return defaultOrderParams;

    const columnKey = Object.keys(sort)[0] as Columns | undefined;

    if (!columnKey) return defaultOrderParams;

    const order = sort[columnKey]?.order || defaultOrderParams.order;

    return {
        orderBy: orderByHandler(columnKey),
        order,
    };
};
